import { UserRoles } from './UserRoles';

//should agree with API format
export interface EditUserData {
    userName: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    email: string;
    roles: UserRoles[];
    colour: string;
}

export interface NewUserData extends EditUserData {
    password: string;
}

export const initialNewUserFormState: NewUserData = {
    userName: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    email: '',
    roles: [UserRoles.CrmUser],
    password: '',
    colour: '#ff1744',
};

export const buildEditUserFormState = (user: EditUserData): EditUserData => {
    return {
        userName: user.userName,
        phoneNumber: user.phoneNumber,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        roles: user.roles,
        colour: user.colour,
    };
};
